import useConnectionsPage from 'new/components/flows/controller/useConnectionsPage';
import { useDirectFlow } from 'new/components/flows/types/DirectFlow/hooks/useDirectFlow';
import { SelectConnection } from 'new/elements/flows/SelectConnection';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import React from 'react';
import useFlowType from '../hooks/useFlowType';
import { CONNECTION_CATEGORY_DATA_MAP } from 'js/constants/connectionCategories';

export const ConnectStep: FCFormPageType<{}> = () => {
  const { nextPage } = useForm();
  const flowType = useFlowType();
  const { connectionType, selectedConnection, onSelectConnection } = useDirectFlow();

  useConnectionsPage(selectedConnection);

  const goToNextStepDismissingValidation = () => nextPage(null, true);
  const onConnectionSelected = async (connection: string) => {
    if (!connection) throw new Error('Enter the connection value to proceed.');

    if (connection === CONNECTION_CATEGORY_DATA_MAP) {
      onSelectConnection(connection);
      await nextPage(2, true);
      return;
    }

    onSelectConnection(connection);
    await goToNextStepDismissingValidation();
  };

  return (
    <SelectConnection
      flowType={flowType}
      connectionType={connectionType}
      selectedConnection={selectedConnection}
      onConnectionSelected={onConnectionSelected}
    />
  );
};

ConnectStep.formConfig = {
  title: 'Connect',
};
